export default "__VITE_ASSET__BeTTV2Nt__"